
import { Component, Vue, Watch } from 'vue-property-decorator'
import { userService } from '@/api/userService'
import AddSchoolManager from './components/add-school-manager.vue'
import UpdateRole from './components/update-role.vue'
import PagedListBase, { PagedRequestDto } from '@/lib/view-base/paged-list-base'
import { UserDto, Int64EntityDto, ResetPasswordDto,CreateUserInput } from '@/api/service-proxies'
import Pagination from '@/components/Pagination/index.vue'
import CreateNewUser from './components/createNewUser.vue'
import OpendialogRrgin from './components/opendialog-Rrgin.vue'

class PageUserRequest extends PagedRequestDto {
  name!: string
  userName!: string
  phoneNumber!: string
}

@Component({
  name: 'User',
  components: {
    Pagination,
    UpdateRole,
    AddSchoolManager,
    CreateNewUser,
    OpendialogRrgin
  },
})
export default class extends PagedListBase<PageUserRequest, UserDto> {
  request = new PageUserRequest()
  schools = []
  showAddSchoolManager = false
  showUpdateRole = false
  currentUserId = 0
  currentUserName = ''
  currentUserPhone = ''
  created() {
    this.refresh()
  }

  getpage(finishCallback: Function): void {
    userService
      .getAll(
        this.request.name,
        this.request.userName,
        this.request.phoneNumber,
        this.request.sorting,
        this.request.skipCount,
        this.request.maxResultCount
      )
      .then((result) => {
        this.list = result.items
        this.showPaging(result)
      })
      .finally(() => {
        finishCallback()
      })
  }

  @Watch('request.name')
  schoolNameChaneged() {
    this.refresh()
  }

  @Watch('request.phoneNumber')
  phoneChanged() {
    this.refresh()
  }

  handleCreate() {
    this.$router.push({ path: '/sys/user/create' })
  }
  handleUpdate(user: UserDto) {
    this.$router.push({ path: `/sys/user/update/${user.id}` })
  }

  addUserDialog(){
    var dialog = this.$refs.createNewUser as CreateNewUser;
    dialog.open()
  }
  opendialogRegin(row){
    var dialog = this.$refs.region as OpendialogRrgin;
    dialog.open(row.id)
  }

  //关联学校
  handleAddSchoolManager(user: UserDto) {
    this.currentUserId = user.id
    this.currentUserName = user.userName
    this.currentUserPhone = user.phoneNumber
    this.showAddSchoolManager = true
  }
  handUpdateRole(user: UserDto) {
    this.currentUserId = user.id
    this.showUpdateRole = true
  }

  async handleActive(user: UserDto) {
    await userService.changeActive(new Int64EntityDto({ id: user.id }))
    this.$notify.success('切换成功')
    this.refresh()
  }
  async handleResetPassword(user: UserDto) {
    this.$confirm('确定重置密码？').then(async () => {
      await userService.resetPassword(new ResetPasswordDto({ userId: user.id }))

      this.$notify.success('已重置密码')
      this.refresh()
    })
  }
  handleDelete(user: UserDto) {
    this.$confirm('确定删除用户?')
      .then(async () => {
        await userService.delete(user.id)
        this.$notify.success('删除成功')
        this.refresh()
      })
      .catch(() => {})
  }
}
